import React, { useState } from 'react';
import classes from './pages.module.css';
import TextCol from "../components/Ui/text/textCol";
import TmList from '../components/Ui/text/tmList';
import TxtList from '../components/Ui/text/txtList';
import TextFull from '../components/Ui/text/textFull';
import BgBlock from '../components/Ui/block/bgBlock';

const Xtower = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Революционная концепция, разработанная архитекторами-градостроителями, создающими города будущего.', span: 'УНИКАЛЬНЫЙ ДИЗАЙН', },
        {id:2, content: 'Обеспечивает универсальность конструкций, скорость сборки, установки и кастомизации под различные архитектурные стили и конфигурации', span: 'МОДУЛЬНОСТЬ'},
        {id:3, content: 'Модульность внутреннего размещения и разграничение доступа - Размещение оборудования 3-х операторов связи и другого оборудования.', span: 'СОВМЕСТНОЕ ИСПОЛЬЗОВАНИЕ'},
        {id:4, content: 'Применяемый в башне материалы обеспечивают проницаемость сигналов с потерями менее 1Дб.', span: 'ДИЭЛЕКТРИЧЕСКАЯ ПРОНИЦАЕМОСТЬ'},
        {id:5, content: 'Различные схемы освещения башни, включая светодиодную подсветку, люминесцирующие панели, источники освещения окружающего пространства.', span: 'ОСВЕЩЕНИЕ'},
        {id:6, content: 'Диэлектрически-проницаемый материал, имитирующий различные материалы: пластик, зеркальные панели, деревянные, каменные и прочие текстуры.', span: 'ВНЕШНЯЯ ОТДЕЛКА'},
        {id:7, content: 'Устанавливается в доступное модульное пространство и может включать в себя системы видеонаблюдения, уличное освещение, сенсоры мониторинга метеорологической и экологической ситуации, модули чистой энергетики, инфопанели для демонстрации рекламной продукции. Все интегрируется внутри пространства башни.', span: 'ДОПОЛНИТЕЛЬНОЕ ОБОРУДОВАНИЕ'},
    ])
    const [posts, setPosts] = useState([
        {id:1, body: 'Интеграция систем Интернета Вещей', title: 'ТЕХНОЛОГИЯ IoT' },
        {id:2, body: 'Архитектурное освещение и уличное освещение пространства вокруг башни', title: 'ДИЗАЙН' },
        {id:3, body: 'Медиа-панели для организации динамического архитектурного стиля, информирования или демонстрации статической и динамической рекламы.', title: 'МЕДИА' },
        {id:4, body: 'Система безопасности с видеокамерами и средствами обнаружения несанкционированного доступа к башне', title: 'БЕЗОПАСНОСТЬ' },
        {id:5, body: 'Средства мониторинга метеорологической и экологической обстановки', title: 'МОНИТОРИНГ' },
        {id:6, body: 'Система инвентаризации и учета ресурсов башни с планшетов и смартфонов по RFID', title: 'КОНТРОЛЬ' },
    ])
    const [lists, setlists] = useState([
        {id:1, list: 'Конструкция постамента, фундамента'},
        {id:2, list: 'Основная конструкция, состоящая из функциональных модулей'},
        {id:3, list: 'Диэлектрически-проницаемые панели светло-голубого цвета'},
        {id:4, list: 'Лестница с жестким якорным устройством-линией'},
        {id:5, list: 'Алюминиевые уголковые конструкции, светлого цвета'},
        {id:6, list: 'Система вертикальной организации кабельного хозяйства'},
        {id:7, list: 'Интегрированная система инвентаризации на базе RFID'},
    ])
    return (
        <>
            <div className={classes.topBlock_small}>
                <div className={classes.top_content}>
                    <h1>X-tower</h1>
                    <div className={classes.devider}></div>
                    <p>Вышки нового поколения X-Tower – башенные конструкции современных архитектурных форм для размещения оборудования телекоммуникационной инфраструктуры.<br></br><br></br>
                        Телекоммуникационные Вышки X-Tower представляют собой современное многофункциональное сооружение, предназначенное для размещения оборудования операторских сетей, для решения задач по мониторингу окружающей среды, освещения, чистой энергетики и рекламы. Также предлагаются различные конфигурации и эксклюзивный дизайн.
                    </p>
                </div>
                <div className={classes.topBg_small}></div>
            </div>
            <TmList textmarkers={texts} title="ОСОБЕННОСТИ X-TOWER"/>
            <TxtList items={posts} title="ПРЕИМУЩЕСТВА X-TOWER"/>
            <BgBlock />
            <TextFull text={{
                title: 'ТИПОВАЯ КОНФИГУРАЦИЯ',
                body: 'Треугольное сечение башни- прочная металлическая конструкция с внешними панелями.',
                body2: 'Внутреннее пространство позволяет размещать операторское оборудование с излучением 360 градусов, специальные модули для прочего оборудования и доступ к этим модулям изнутри.'
            }} lists={lists} />
        </>
    )
}

export default Xtower;